import { forwardRef, useState, useEffect, ChangeEvent } from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import type { FieldChangeEvent } from '../hooks/types';
import { Input } from './input.component';
import type { InputProps } from './types';

const dateNavigatorInputStyle = css`
  font-size: ${theme.fontSize(12)};
`;

export const DateNavigatorInput = forwardRef<HTMLInputElement, InputProps<'text'>>(
  ({ value = '', onChange, className, ...rest }, ref) => {
    // Local state is used to allow typing spaces at end of the input string
    // which gets trimmed while getting value from `useForm` or `useFormField`.
    // We need it to enter dates like "Jan 21" or "next week" etc.
    const [localValue, setLocalValue] = useState<string>(value);

    const handleChange = (event?: FieldChangeEvent) => {
      setLocalValue((event as ChangeEvent<HTMLInputElement>).target.value);
      onChange(event);
    };

    // Sync local value when prop value changes
    useEffect(() => {
      setLocalValue(value || '');
    }, [value]);

    return (
      <Input
        type='text'
        value={localValue}
        className={cx(dateNavigatorInputStyle, className)}
        onChange={handleChange}
        ref={ref}
        {...rest}
      />
    );
  }
);

DateNavigatorInput.displayName = 'DateNavigatorInput';
